import { useTranslation } from 'react-i18next'
import {
  isSupplierOrder,
  useUpdateOrderInternalMutation,
  useUpdateOrderSuppliersMutation,
} from '../../../redux/api/ordersApi'
import { TransparentButton, ButtonType } from '../../common/Buttons/TransparentButton'
import { Dialog } from '../../common/Dialog/Dialog'
import './TextModal.scss'
import { useEffect, useState } from 'react'
import {
  OrderInternalFormFieldViewModel,
  OrderInternalInputModel,
  OrderInternalViewModel,
  OrderSuppliersFormFieldViewModel,
  OrderSuppliersInputModel,
  OrderSuppliersViewModel,
  WorkflowOrderStepStatus,
} from '@ail/orders-api'

interface TextModalProps {
  data?: {
    order: OrderInternalViewModel | OrderSuppliersViewModel
    field: OrderInternalFormFieldViewModel | OrderSuppliersFormFieldViewModel
  }
  onClose: () => void
}

export function TextModal(props: TextModalProps) {
  const [value, setValue] = useState('')
  const [t, i18n] = useTranslation()
  const [updateOrderInternal] = useUpdateOrderInternalMutation({ fixedCacheKey: 'UpdateInternal' })
  const [updateOrderSuppliers] = useUpdateOrderSuppliersMutation({ fixedCacheKey: 'UpdateSuppliers' })

  const title = props.data?.field?.tr?.[i18n.language] ?? props.data?.field?.tr?.['en'] ?? ''

  const update = () => {
    if (!props.data) {
      return
    }

    const { order, field } = props.data

    const model: OrderInternalInputModel | OrderSuppliersInputModel = {
      form: {
        ...order.form,
        fields: [{ name: field.name, value, documents: [] }],
      },
    }

    if (isSupplierOrder(order)) {
      if (model.form.status === WorkflowOrderStepStatus.New) {
        model.form.status = WorkflowOrderStepStatus.InProgress
      }
      updateOrderSuppliers({ id: order.id, model })
    } else {
      updateOrderInternal({ id: order.id, model })
    }
    props.onClose()
  }

  useEffect(() => {
    setValue(props.data?.field.value ?? '')
  }, [props.data])

  return (
    <Dialog open={!!props.data} title={title} onClose={props.onClose} icon="icon-edit" width={450}>
      <div className="text-modal">
        <div className="inputArea">
          <input type="text" value={value} className="transparent" onChange={(e) => setValue(e.target.value)} />
        </div>
        <div className="text-modal-actions">
          <TransparentButton type={ButtonType.Negative} icon="icon-close" onClick={props.onClose} name={t('CANCEL')} />
          <TransparentButton type={ButtonType.Positive} icon="icon-check" onClick={update} name={t('UPDATE')} />
        </div>
      </div>
    </Dialog>
  )
}
